import { apiClient } from "../api/apiclient"

export const getAcademicYear = (token) =>
    apiClient.get("/academicsession", {
        headers: { Authorization: `Bearer ${token}` },
    });


export const postProjectConfig = (projectConfiguration, token, academicSessionId) =>
    apiClient.post("/project-configurations", projectConfiguration, {
        headers: { Authorization: `Bearer ${token}` },
        params: { academicSessionId }
    });

export const getAllProjectConfigurations = () =>
    apiClient.get("/public/project-configurations", {
        // headers: { Authorization: `Bearer ${token}` },
    });